import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { CreateWizardModule } from '@mirage-projects/cw-ui-components';

import { DirectivesModule } from '../../directives/directives.module';
import { NotificationDrawerModule } from '../notification-drawer/notification-drawer.module';
import { AboutDialogComponent } from './about-dialog/about-dialog.component';
import { ChangeTwcIconsSizeDirective } from './change-twc-icons-size.directive';
import { TopbarComponent } from './topbar.component';

@NgModule({
    declarations: [TopbarComponent, ChangeTwcIconsSizeDirective, AboutDialogComponent],
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        NotificationDrawerModule,
        DirectivesModule,
        CreateWizardModule,
    ],
    exports: [TopbarComponent],
})
export class TopbarModule {}
